import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { ChatListComponent } from '@app/ai-chat/chat-list/chat-list.component';
import { ChatConversationAreaComponent } from '@app/ai-chat/chat-conversation-area/chat-conversation-area.component';
import { AiChatService } from '@app/ai-chat/services/ai-chat.service';
import { MatIconModule } from '@angular/material/icon';
import { NewRightSidebarService } from '@app/layout/new-right-sidebar/services/new-right-sidebar/new-right-sidebar.service';
import { AuCloseButtonComponent } from '@app/shared/ui-components/au-close-button/au-close-button.component';

@Component({
	selector: 'ai-chat',
	imports: [
		CommonModule,
		ChatListComponent,
		ChatConversationAreaComponent,
		MatIconModule,
		AuCloseButtonComponent,
	],
	templateUrl: './ai-chat.component.html',
	styleUrls: ['./ai-chat.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [AiChatService],
})
export class AiChatComponent {
	private readonly sidebarService = inject(NewRightSidebarService);
	isFullscreen$: Observable<boolean>;

	protected close(): void {
		this.sidebarService.close();
	}
}
